/**
 * Overridable editor text. Hosts replace any entry through
 * `services.editorPresentation.text` (or `proof-authoring.options.editor.text`).
 * Keys are stable; values are the default English wording.
 */
export const editorTextDefaults = {
  "fields.heading": "Fields & variables",
  "fields.description": "Define your information once. Bring it to every design.",
  "fields.tab.fields": "Fields",
  "fields.tab.layout": "Form layout",
  "fields.tab.parts": "Part overrides",
  "fields.tab.forms": "Reusable forms",
  "fields.tab.rules": "Rules & presets",
  "fields.tab.data": "Data & presets",
  "fields.list.heading": "Project variables",
  "fields.list.description": "Input controls and data bindings",
  "fields.action.addField": "Add field",
  "fields.action.generateForm": "Generate Form",
  "fields.action.viewForm": "View Form",
  "fields.action.generateGlobalForm": "Generate global form",
  "fields.action.generateProfileForm": "Generate global profile form",
  "fields.section.display": "Form display",
  "fields.section.calculated": "Calculated value",
  "fields.section.validation": "Validation",
  "fields.section.formatting": "Formatting",
  "layout.heading": "Form layout",
  "layout.action.addColumn": "Add column",
  "layout.action.addSection": "Add section",
  "layout.action.addTab": "Add tab",
  "layout.fieldSelector": "Select a field",
  "layout.addField": "+ Add a field",
  "form.action.save": "Save",
  "form.action.cancel": "Cancel",
} as const;
export type EditorTextKey = keyof typeof editorTextDefaults;
export type EditorText = Partial<Record<EditorTextKey, string>>;

/** Resolve one entry, ignoring blank overrides. */
export function editorText(
  overrides: EditorText | undefined,
  key: EditorTextKey,
): string {
  const value = overrides?.[key];
  return typeof value === "string" && value.trim()
    ? value
    : editorTextDefaults[key];
}
